import React from "react";
import comingSoonImg from "../assets/comingSoon.jpg";
import { FaApple } from "react-icons/fa";
import { FaRadio } from "react-icons/fa6";
import { IoLogoAndroid } from "react-icons/io";

export default function ComingSoon() {
  return (
    <div className="bg-white font-energetic p-4 sm:pt-10 lg:p-12 border-t-[1px] border-solid border-gray-600
    text-orange-100 font-energetic"
      style={{
        backgroundImage:
          `linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.1)), url(${comingSoonImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        // height: "400px",
      }}>
      <div className="mx-auto max-w-screen-2xl px-4 md:px-8 h-full">
        {/* <img src={alter} alt="coming soon" /><h2 className="text-2xl text-white font-bold sm:text-3xl">Coming Soon to Your Devices</h2> */}
        <h2 className="text-2xl text-white font-bold sm:text-3xl text-center">Coming Soon to Your Devices</h2>
        <p className="text-center mb-12">Get ready to experience Radio O everywhere you go!
          We're launching soon on:</p>
        <div className="sm:flex flex-col gap-12 md:grid grid-cols-3">
          <div className="bg-gray-300 p-4 m-3 rounded-lg shadow-lg" data-aos="flip-left">
            <span className="text-center flex justify-center p-2"><IoLogoAndroid color="black" size={40} /></span>
            <span className="block text-lg font-semibold text-black text-center">Android App</span>
            <span className="block mt-1 text-black p-2 text-justify">Stream Radio O anytime, anywhere on your Android device.</span>
          </div>
          <div className="bg-gray-300 p-4 m-3 rounded-lg shadow-lg" data-aos="flip-right">
            <span className="text-center flex justify-center p-2"><FaApple color="black" size={40} /></span>
            <span className="block text-lg font-semibold text-black text-center">Apple iOS App</span>
            <span className="block mt-1 text-black p-2">Radio O is coming to your iPhone and iPad — sleek, fast, and always on.</span>
          </div>
          <div className="bg-gray-300 p-4 m-3 rounded-lg shadow-lg" data-aos="flip-up">
            <span className="text-center flex justify-center p-2"><FaRadio color="black" size={40} /></span>
            <span className="block text-lg font-semibold text-black text-center">DAB Digital Radio</span>
            <span className="block mt-1 text-black p-2">Tune in on DAB radios across the country for high-quality broadcast.</span></div>
        </div>
      </div>
    </div>
  );
}
